import axios from 'axios'

import env from '@/../.env'

function getUrl() {
    let url = env.API_FILE_URL
    let currentDomainName = window.location.hostname
    let configSpace = localStorage['space-conf'] ? JSON.parse(localStorage['space-conf']) : null;
    const demoUrls = ['localhost', 'savlog.3w-dev.com', 'demo.savlog.net']

    if ((configSpace && (configSpace.demo == '1' || configSpace.demo == 1)) || demoUrls.includes(currentDomainName)) {
        url = env.API_DEMO_FILE_URL
    }
    return url
}

var myaxiosUpload = axios.create({
    baseURL: getUrl()
})

export default myaxiosUpload



// WEBPACK FOOTER //
// ./src/services/axiosUpload.service.js